import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/autorizador`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        activate(id) {
            return repository.put(`${baseUrl}/${id}/activate`)
        },
        deactivate(id) {
            return repository.put(`${baseUrl}/${id}/deactivate`)
        },
        autocomplete(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        profissional: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-profissional?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}
